<template>
	<div id="app">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>
<script>
import wxConfig from './util/wxConfig.js'
export default {
	data() {
		return {
			wxJssdk: false
		}
	},
	created() {
		wxConfig.init().then(() => {
			this.wxJssdk = true
		})
	}
}
</script>

<style>
	body {
		font-family: 'Microsoft YaHei', arial, verdana, \u5fae\u8f6f\u96c5\u9ed1, \u9ed1\u4f53;
		padding: 0;
		margin: 0;
		width: 100%;
		background: #EDF0F7;
	}
	ul p,
	h3 {
		margin: 0;
		padding: 0;
	}
	.one-line {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue